import { useState, useEffect} from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { Link } from 'react-router-dom';


export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  // const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [delta, setDelta] = useState(160); // set delta to a constant value
  const [index, setIndex] = useState(1);
  const toRotate = [ " Aspiring Data Analyst", "Software Developer", "ML/AI Developer" ];
  const period = 900;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])
  

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(150);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }
  
  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Welcome to my Portfolio</span>
                <br></br>
                <br></br>
                <br></br>
                <h1> {`Hi! I'm Munqiz Minhas `} <span className="txt-rotate" dataPeriod="1000" data-rotate='[ " Aspiring Data Analyst", "Software Developer", "ML/AI Developer" ]'><span className="wrap">{text}</span></span></h1>
                  <p>Data Analyst with a certificate in Fintech from Arizona State University and skilled in Python,
                    Pandas, and Machine Learning. Proven technical and leadership aptitude in data analysis and
                    financial modeling and forecasting. Qualifications encompass collaborating across teams to
                    define needs, evaluate risks and issues, and implement solutions. Enjoys leveraging background
                    and skill set to support detailed and efficient analysis.
                    </p>
                    <a href="/Resume.pdf#zoom=125" target="_blank" rel="noopener noreferrer">
                    <button className="resume-btn" >Resume <ArrowRightCircle size={25} /></button>
                    </a>
                <br></br>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}